<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-50 space-y-2 max-w-md w-full pointer-events-none">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto rounded-lg shadow-lg p-4 border backdrop-blur-sm"
          :class="getToastClasses(toast.type)"
          @click="remove(toast.id)"
        >
          <div class="flex items-start">
            <div class="flex-shrink-0 mr-3">
              <span class="text-xl">{{ getToastIcon(toast.type) }}</span>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium" :class="getToastTextClass(toast.type)">
                {{ toast.message }}
              </p>
            </div>
            <button
              @click.stop="remove(toast.id)"
              class="ml-3 flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const { toasts, remove } = useToast()

const getToastClasses = (type?: string) => {
  const baseClasses = 'bg-white border-l-4'
  switch (type) {
    case 'success':
      return `${baseClasses} border-green-500 bg-green-50`
    case 'error':
      return `${baseClasses} border-red-500 bg-red-50`
    case 'warning':
      return `${baseClasses} border-yellow-500 bg-yellow-50`
    case 'info':
      return `${baseClasses} border-blue-500 bg-blue-50`
    default:
      return `${baseClasses} border-gray-500 bg-gray-50`
  }
}

const getToastTextClass = (type?: string) => {
  switch (type) {
    case 'success':
      return 'text-green-800'
    case 'error':
      return 'text-red-800'
    case 'warning':
      return 'text-yellow-800'
    case 'info':
      return 'text-blue-800'
    default:
      return 'text-gray-800'
  }
}

const getToastIcon = (type?: string) => {
  switch (type) {
    case 'success':
      return '✅'
    case 'error':
      return '❌'
    case 'warning':
      return '⚠️'
    case 'info':
      return 'ℹ️'
    default:
      return '📢'
  }
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>

